import { api_json } from './api'

export type SessionUser = {
  id: string | number
  email: string
  name?: string | null
  role: string
  must_change_password?: boolean
  totp_pending_setup?: boolean
  totp_enabled?: boolean
}

export async function get_session_user(): Promise<SessionUser | null> {
  try {
    const me = await api_json<{ user?: SessionUser }>('/api/auth/me')
    return me && me.user ? me.user : null
  } catch {
    return null
  }
}